import React, { lazy } from 'react'
import { Navigate, RouteObject } from 'react-router-dom'
// Navigate

const TextCtr = lazy(() => import('@/views/text'))
const Login = lazy(() => import('@/views/login'))
const Layout = lazy(() => import('@/views/layout'))
const Home = lazy(() => import('@/views/page/home'))
const Courses = lazy(() => import('@/views/page/courses'))

const StudyInChina = lazy(() => import('@/views/page/studyInChina'))
const SchoolList = lazy(
  () => import('@/views/page/studyInChina/c-childrens/studySchool')
)
const SchoolDetails = lazy(
  () => import('@/views/page/studyInChina/c-childrens/schoolDetails')
)

const StudyTour = lazy(() => import('@/views/page/studyTour'))
const Details = lazy(() => import('@/views/page/studyTour/childrenCtr/details'))

const Download = lazy(() => import('@/views/page/download'))
const AboutUs = lazy(() => import('@/views/page/aboutUs'))
const Teachers = lazy(() => import('@/views/page/teachers'))
const Reading = lazy(() => import('@/views/page/readingCtr'))
const IfromPageCtr = lazy(() => import('@/views/ifromPage/index'))
const MyScheduleCtr = lazy(() => import('@/views/ifromPage/studyCtr/myScheduleCtr'))
const routers: RouteObject[] = [
  {
    path: '/',
    element: <Navigate to="/id" />
  },
  {
    path: '/id',
    element: <Layout />,
    // <Navigate to="/id" />,
    children: [
      {
        path: '/id',
        element: <Navigate to="/id/homeCtr" />
      },
      {
        path: '/id/homeCtr',
        element: <Home />
      },
      {
        path: '/id/coursesCtr',
        element: <Courses />
      },
      {
        path: '/id/studyInChinaCtr',
        element: <StudyInChina />
      },
      { path: '/id/SchoolListCtr', element: <SchoolList /> },
      { path: '/id/schoolDetailsCtr', element: <SchoolDetails /> },

      // onClick={() => { navigate('/id/readingCtr') }}
      { path: '/id/readingCtr', element: <Reading /> },
      {
        path: '/id/studyTourCtr',
        element: <StudyTour />
      },
      {
        path: '/id/studyTourDetailsCtr',
        element: <Details />
      },
      {
        path: '/id/aboutUsCtr',
        element: <AboutUs />
      },
      {
        path: '/id/downloadCtr',
        element: <Download />
      },
      {
        path: '/id/teachersCtr',
        element: <Teachers />
      },
      {
        path:'/id/officialWebsiteCtr',
        element: <IfromPageCtr />
      }
    ]
  },

  {
    path: '/LoginCtr',
    element: <Login />
  },
  {
    path:'/id/studyCtr',
    children: [
      {
        path: 'myScheduleCtr',
        element: <MyScheduleCtr />
      }
    ]
  },
  {
    path: '/textCtr',
    element: <TextCtr />,
    children: [
      {
        path: 'aboutUsCtr',
        element: <AboutUs />
      }
    ]
  },
  {
    path: '*',
    element: <Navigate to="/id/homeCtr" />
  },
]
export default routers
